export class Category {
  id: number = null;
  name: string = null;
  value = false;
  eft: number = null;
}
